import React from 'react';
import ActionItems from './ActionItems';
import './ActionItems.css';

const InfoSection = () => {
  const containerStyle = {
    maxWidth: '800px',
    margin: '0 auto',
    textAlign: 'left',
    padding: '2rem'
  };

  const paragraphStyle = {
    marginBottom: '1.5rem',
    fontSize: '1.125rem',
    lineHeight: '1.6',
    color: 'white'
  };

  // Scroll to the representative section when the button is clicked
  const scrollToRepresentativeSearch = () => {
    const repSection = document.querySelector('.representative-section');
    if (repSection) {
      repSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="info-section" style={containerStyle}>
      <header style={{ marginBottom: '2rem' }}>
        <h2
          className="impact-header"
          style={{ color: 'white', fontSize: '2rem', marginBottom: '1rem' }}
        >
          <span style={{ color: '#4a90e2' }}>
          A bipartisan coalition
          </span> in the Texas House is fighting to fund our local schools and champion our students.
          <br /><br />
          <span style={{ color: '#bc1823' }}>Greg Abbott</span> is fighting to defund our schools and champion his billionaire mega-donors.
          <br />
        </h2>
      </header>

      <section style={{ marginBottom: '2rem' }}>
        <h2
          className="impact-header"
          style={{
            color: 'white',
            fontSize: '2rem',
            marginBottom: '1rem'
          }}
        >
          Vouchers are a scam.
        </h2>
        <p style={paragraphStyle}>
          Vouchers take your taxpayer dollars from your local school to subsidize private education for the wealthy few. Voucher scams do not improve your child's education, but they do give wealthy parents a discount on their private school tuition.
        </p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2
          className="impact-header"
          style={{
            color: 'white',
            fontSize: '2rem',
            marginBottom: '1rem'
          }}
        >
          Voucher scams will raise your property taxes.
        </h2>
        <p style={paragraphStyle}>
        Texans pay more in property taxes than California, Florida, and 41 other states because Greg Abbott has systematically underfunded our public schools for years. To stop the bleeding, local school districts are forced to raise property tax rates. Vouchers will take even more money away from our classrooms, forcing school districts to raise your tax rates even more. With voucher scams, you pay more — for less.
        </p>
      </section>
      <section style={{ marginBottom: '2rem' }}>
        <h2
          className="impact-header"
          style={{
            color: 'white',
            fontSize: '2rem',
            marginBottom: '1rem'
          }}
        >
          Voucher scams are backed by billionaires, not Texans.
        </h2>
        <p style={paragraphStyle}>
        For decades, a bipartisan coalition has rejected voucher scams. The only thing that's changed is the tens of millions that billionaires like Tim Dunn, Farris Wilks, and Jeff Yass are spending to push voucher scams in Texas. They're lying about public schools and public officials because vouchers serve their interests — not yours.
        </p>
      </section>

      <section>
        <h2
          className="impact-header"
          style={{
            color: 'white',
            fontSize: '2rem',
            marginBottom: '1rem'
          }}
        >
          Texas public schools are closing after Greg Abbott held our schools and students hostage.
        </h2>
        <p style={paragraphStyle}>
        Greg Abbott has provided zero dollars in new basic funding for our local schools in the past four years. Last legislative session, after a bipartisan pro-public education coalition in the Texas House defeated his voucher scam, Abbott retaliated by holding new funding for our schools hostage. Now, countless districts are cutting programs and closing schools amid budget shortfalls.
        </p>
      </section>

      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <button className="tel-button" onClick={scrollToRepresentativeSearch}>
          How do I fight back?
        </button>
        <ActionItems position="button" />
      </div>
    </div>
  );
};

export default InfoSection; 